import { MemberRole, TribeMembershipDetails } from 'src/api/circles';

/**
 * Whether a leader may remove a member from the circle, and why not.
 * Mirrors the mobile app and the API: a leader cannot be removed, and
 * nobody removes themselves.
 */
export type RemovalState = 'removable' | 'leader' | 'self';

export const removalState = (
  member: TribeMembershipDetails,
  currentUserId: string | undefined
): RemovalState => {
  if (member.role === MemberRole.Leader) {
    return 'leader';
  }
  if (currentUserId && member.user?._id === currentUserId) {
    return 'self';
  }
  return 'removable';
};

export const removeConfirmText = (name: string): string =>
  `Remove ${name} from the Circle? They lose access to the Circle in the app and on the web. You can add them again later.`;
